import USER_ORG_ROLES from '../constants/userOrgRoles'
import { USER_ADDONS } from '../constants/userAddons'
import isUserOrgRolesValid from './isUserOrgRolesValid'
import isUserAddonsValid from './isUserAddonsValid'

const isStatistician = () =>
  isUserOrgRolesValid([USER_ORG_ROLES.MEMBER]) && isUserAddonsValid([USER_ADDONS.STATS])

export default isStatistician
